var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "m14" },
    [
      _c("el-card", { staticClass: "content employees-card" }, [
        _c("div", { staticClass: "from-s mt14" }, [
          _c(
            "div",
            { staticClass: "flex-row flex-col" },
            [
              _c("form-box", {
                ref: "formBox",
                on: { confirmData: _vm.confirmData },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt10" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                ref: "table",
                attrs: { data: _vm.tableData, height: _vm.tableHeight },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "35" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "查看", width: "50" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-image", {
                            attrs: {
                              src:
                                scope.row.is_read === 0
                                  ? require("@/assets/images/unread-icon.png")
                                  : require("@/assets/images/read-icon.png"),
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "title",
                    label: "消息标题",
                    "min-width": "80",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "message",
                    label: "消息内容",
                    "min-width": "360",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "notice" }, [
                            _vm._v(_vm._s(scope.row.message)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "cate_name",
                    label: "类型",
                    "min-width": "80",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "created_at",
                    label: "发送时间",
                    "min-width": "120",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("toptable.operation"),
                    width: "100",
                    fixed: "right",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return _vm._l(
                          scope.row.buttons,
                          function (item, index) {
                            return _c(
                              "el-button",
                              {
                                key: index,
                                attrs: {
                                  type: "text",
                                  disabled: _vm.selectedType.includes(
                                    item.action
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetails(scope.row, item)
                                  },
                                },
                              },
                              [
                                scope.row.cate_name !== "考勤"
                                  ? _c("span", [
                                      _vm._v(" " + _vm._s(item.title)),
                                    ])
                                  : _vm._e(),
                              ]
                            )
                          }
                        )
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "footer" }, [
          _c("div", { staticClass: "isSelect" }, [
            _c(
              "div",
              { staticClass: "flex", staticStyle: { display: "inline-block" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      size: "small",
                      disabled: _vm.multipleSelection.length == 0,
                    },
                    on: { click: _vm.handleIsRead },
                  },
                  [_vm._v("标记为已读")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      size: "small",
                      disabled: _vm.multipleSelection.length == 0,
                    },
                    on: { click: _vm.handleDelete },
                  },
                  [_vm._v("批量删除")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.multipleSelection.length !== 0
              ? _c("span", [
                  _vm._v(
                    "已选中" + _vm._s(_vm.multipleSelection.length) + " 条"
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "paginationClass" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-size": _vm.where.limit,
                  "current-page": _vm.where.page,
                  "page-sizes": [10, 15, 20],
                  layout: "total, sizes,prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("dialog-form", {
        ref: "dialogForm",
        attrs: {
          "roles-config": _vm.rolesConfig,
          "form-data": _vm.formBoxConfig,
        },
        on: {
          isOk: function ($event) {
            return _vm.getList()
          },
        },
      }),
      _vm._v(" "),
      _c("message-details", {
        ref: "messageDetails",
        attrs: { "message-data": _vm.messageData },
        on: { isOk: _vm.isOk },
      }),
      _vm._v(" "),
      _c("message-handle-popup", {
        ref: "messageHandlePopup",
        attrs: { detail: _vm.detail },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }